<template>
	<div>
		<div class="row mb-2" v-if="!loading">
			<div
				class="col-md-4"
				v-for="(item, index) in getAccountTopEngagements"
				:key="index"
			>
				<router-link :to="'/account/' + item.id + '/profiles'">
					<div class="card card-rank">
						<div class="card-body pt-2 pb-2">
							<div class="text-dark text-muted">
								{{ ordinalNum(index + 1) }}
							</div>
							<div class="text-center">
								<div class="font-weight-bold text-dark font-size-21">
									{{ item.name }}
								</div>
								<p>{{ item.aGName }}</p>
								<div>{{ item.engagement + '%' }}</div>
							</div>
						</div>
					</div>
				</router-link>
			</div>
		</div>

		<div class="row mb-2" v-if="loading">
			<div class="col-md-4">
				<a-skeleton
					active
					:paragraph="{ rows: 3, width: '100%' }"
					:title="false"
				/>
			</div>
			<div class="col-md-4">
				<a-skeleton
					active
					:paragraph="{ rows: 3, width: '100%' }"
					:title="false"
				/>
			</div>
			<div class="col-md-4">
				<a-skeleton
					active
					:paragraph="{ rows: 3, width: '100%' }"
					:title="false"
				/>
			</div>
		</div>
	</div>
</template>

<script>
import * as ACTIONS from '@/store/actions'
import { mapGetters, mapActions } from 'vuex'

export default {
	name: 'TopEngagement',
	props: {
		accountType: {
			type: Number,
			required: true,
		},
	},
	data: function() {
		return {
			loading: false,
		}
	},
	created() {
		this.loading = true
		this.loadAccountTopEngagement({
			where: {
				typeId: this.accountType,
			},
			limit: 3,
			order: ['engagement DESC'],
		}).then(res => {
			this.loading = false
		})
	},
	watch: {
		accountType: function(newVal) {
			this.loading = true
			this.loadAccountTopEngagement({
				where: {
					typeId: newVal,
				},
				limit: 3,
				order: ['engagement DESC'],
			}).then(res => {
				this.loading = false
			})
		},
	},
	methods: {
		// prettier-ignore
		ordinalNum(n) {
			// eslint-disable-next-line indent
			return (n + (n > 0 ? ['th', 'st', 'nd', 'rd'][ (n > 3 && n < 21) || n % 10 > 3 ? 0 : n % 10 ] : ''))
		},
		...mapActions({
			loadAccountTopEngagement: ACTIONS.ACCOUNT.TOP_ENGAGEMENT,
		}),
	},
	computed: {
		...mapGetters(['getAccountTopEngagements']),
	},
}
</script>

<style></style>
